import { ButtonCtaDto } from "../Models/ButtonCtaDto";

export default () => {
    const getDictionary = async (fetchBase : string, culture : string) : Promise<Map<string, string>> => {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/dictionary?set=myaccount`, {
                'credentials': 'include',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, string>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                map.set(key, value as string);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    const getButtonCtas = async (fetchBase : string, culture : string) : Promise<Map<string, ButtonCtaDto>> => {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/translation/button-ctas`, {
                'credentials': 'include',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, ButtonCtaDto>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of data.data.map(x => [x.fetchKey, x])) {
                map.set(key, value as ButtonCtaDto);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }


    return { getDictionary, getButtonCtas };
}